import styled from 'styled-components';
import { SelectSingleValueTag } from '../../../../packages/pareto-style/select/SelectSingleValue';
import { Row } from '../../common.styles';
import { ColorConstants } from '../../../constants';

export const RowTextFieldWithMenuDropdown = styled(Row)`
  ${SelectSingleValueTag} {
        padding: 5px 0px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const selectStyles = {
    container: styles => ({
        ...styles,
        width: '100%',
    }),
    control: (styles, state) => ({
        ...styles,
        border: 'unset',
        boxShadow: 'unset',
        backgroundColor: state.isDisabled ? ColorConstants.GRAY_5 : 'transparent',
    }),
    input: styles => ({
        ...styles,
        border: 'unset',
    }),
    placeholder: styles => ({
        ...styles,
        padding: 0,
    }),
};
